module.exports = __webpack_public_path__ + "static/keyword_5-ea593ddeb02d7f99e889d1726a1c2a31.jpg";